export const getStatusIcon = (status) => {
    const iconStyles = {
      queued: { icon: "fa-clock", color: "#999" },
      sending: { icon: "fa-paper-plane", color: "#17a2b8" },
      sent: { icon: "fa-check", color: "#007bff" },
      delivered: { icon: "fa-check-double", color: "#28a745" },
      read: { icon: "fa-eye", color: "#007bff" },
      failed: { icon: "fa-times-circle", color: "#dc3545" },
      undelivered: { icon: "fa-exclamation-triangle", color: "#ffc107" },
      partially_delivered: { icon: "fa-dot-circle", color: "#ffc107" },
      canceled: { icon: "fa-ban", color: "#6c757d" },
      accepted: { icon: "fa-thumbs-up", color: "#6f42c1" },
      receiving: { icon: "fa-download", color: "#17a2b8" },
      received: { icon: "fa-inbox", color: "#28a745" },
      scheduled: { icon: "fa-calendar-alt", color: "#6c757d" }
    };
    return iconStyles[status] || { icon: "fa-question-circle", color: "#6c757d" };
  };
